export interface RoutesObject {
    title: string;
    route: string;
    type?: string;
}

export interface RoutesInterface {
    HOME: RoutesObject;
    DASHBOARD: RoutesObject;
    JOB_MANAGEMENT: RoutesObject;
    JOB_MANAGEMENT_FOR_TAB: RoutesObject;
    JOB_PROFILE_WITH_ID: RoutesObject;
    REPORTING: RoutesObject;
    DRIVER_REPORT: RoutesObject;
    POWER_BI_REPORT: RoutesObject;
    SYSTEM_ADMIN_USERS: RoutesObject;
    SYSTEM_ADMIN_PERMISSIONS: RoutesObject;
    SYSTEM_ADMIN_LOFAS: RoutesObject;
    SYSTEM_ADMIN_CREWS: RoutesObject;
    SYSTEM_ADMIN_CUSTOMERS: RoutesObject;
    SYSTEM_ADMIN_CUSTOMER_PARENTS: RoutesObject;
    SYSTEM_ADMIN_PROPANTS: RoutesObject;
    SYSTEM_ADMIN_DRIVERS: RoutesObject;
    SYSTEM_ADMIN_CARRIERS: RoutesObject;
    SYSTEM_ADMIN: RoutesObject;
    SYSTEM_ADMIN_SETTINGS: RoutesObject;
    SYSTEM_ADMIN_YARDS: RoutesObject;
    EMAIL: RoutesObject;
    PROFILE: RoutesObject;
    CALLBACK: RoutesObject;
    SILENT_RENEW: RoutesObject;
    JOB_PROFILE: RoutesObject;
    LOAD_MANAGEMENT: RoutesObject;
    LOAD_MANAGEMENT_WITH_ID: RoutesObject;
    EDIT_JOB: RoutesObject;
    EDIT_JOB_WITH_ID: RoutesObject;
    JOB_LOADS: RoutesObject;
    JOB_LOADS_WITH_ID: RoutesObject;
    LOAD_PROFILE: RoutesObject;
    LOAD_FIELD_OP: RoutesObject;
    LOAD_FIELD_OP_WITH_ID: RoutesObject;
    LOAD_PROFILE_WITH_ID: RoutesObject;
    CHANGE_PASSWORD: RoutesObject;
    LOAD_HISTORY: RoutesObject;
    LOAD_HISTORY_WITH_ID: RoutesObject;
    JOB_ACTIVITY: RoutesObject;
    STAGE_SUMMARY: RoutesObject;
    STAGE_SUMMARY_WITH_ID: RoutesObject;
    STAGE_SHEET: RoutesObject;
    STAGE_SHEET_BELLY_DUMP: RoutesObject;
    STAGE_SHEET_BELLY_DUMP_WITH_ID: RoutesObject
    STAGE_SHEET_WITH_ID: RoutesObject;
    STAGE_SHEET_RO: RoutesObject;
    STAGE_SHEET_RO_WITH_ID: RoutesObject;
    STAGE_SHEET_BELLY_DUMP_RO: RoutesObject;
    STAGE_SHEET_BELLY_DUMP_RO_WITH_ID: RoutesObject;
    DRIVER_POOL: RoutesObject;
    DRIVER_POOL_WITH_ID: RoutesObject;
    DAILY_SAND_ALLOCATIONS: RoutesObject;
    DAILY_SAND_ALLOCATIONS_WITH_ID: RoutesObject;
    JOB_METRICS: RoutesObject;
    JOB_METRICS_WITH_ID: RoutesObject;
    INVENTORY: RoutesObject;
    INVENTORY_WITH_ID: RoutesObject;
    JOB_LOGS: RoutesObject;
    JOB_LOGS_WITH_ID: RoutesObject;
    ADD_BOXES: RoutesObject;
    ADD_BOXES_WITH_ID: RoutesObject;
    JOB_ACTIVITY_WITH_ID: RoutesObject;
    JOB_MAP: RoutesObject;
    JOB_MAP_WITH_ID: RoutesObject;
    MESSAGES: RoutesObject;
    MESSAGES_WITH_ID: RoutesObject;
    MESSAGES_WITH_DRIVER_ID: RoutesObject;
    MESSAGES_CREATE: RoutesObject;
    EQUIPMENT: RoutesObject;
    EQUIPMENT_WITH_ID: RoutesObject;
    EQUIPMENT_MANAGEMENT: RoutesObject;
    EQUIPMENT_MANAGEMENT_WITH_ID: RoutesObject;
    EDIT_ASSET_LOAD: RoutesObject;
    EDIT_ASSET_LOAD_WITH_ID: RoutesObject;
    EQUIPMENT_HISTORY: RoutesObject;
    EQUIPMENT_HISTORY_WITH_ID: RoutesObject;
    VOS:RoutesObject;
    VOS_WITH_ID:RoutesObject;
    DASHBOARD_VOS:RoutesObject;
    DASHBOARD_MAP: RoutesObject
}

export const Routes: RoutesInterface = {
    HOME: {
        title: 'Home',
        route: '/',
    },
    DASHBOARD: {
        title: 'Dashboard',
        route: '/dashboard',
    },
    JOB_MANAGEMENT: {
        title: 'Job Management',
        route: '/job',
    },
    JOB_MANAGEMENT_FOR_TAB: {
        title: 'Job Management',
        route: '/job_tab',
    },
    JOB_PROFILE_WITH_ID: {
        title: 'Job Profile',
        route: '/job_profile/:jobId',
    },
    REPORTING: {
        title: 'Reporting',
        route: '/reporting',
    },
    DRIVER_REPORT: {
        title: 'Driver Report',
        route: '/driver_report',
    },
    POWER_BI_REPORT: {
        title: 'Load Report',
        route: '/sandbox_bi',
    },
    SYSTEM_ADMIN: {
        title: 'System Admin',
        route: '/system_admin',
    },
    SYSTEM_ADMIN_USERS: {
        title: 'Users',
        route: '/system_admin_users',
    },
    SYSTEM_ADMIN_PERMISSIONS: {
        title: 'Permissions',
        route: '/system_admin_permissions',
    },
    SYSTEM_ADMIN_LOFAS: {
        title: 'Lofas',
        route: '/system_admin_lofas',
    },
    SYSTEM_ADMIN_CREWS: {
        title: 'Crews',
        route: '/system_admin_crews',
    },
    SYSTEM_ADMIN_CUSTOMERS: {
        title: 'Customers',
        route: '/system_admin_customers',
    },
    SYSTEM_ADMIN_CUSTOMER_PARENTS: {
        title: 'Customer Parents',
        route: '/system_admin_customerparents',
    },
    SYSTEM_ADMIN_PROPANTS: {
        title: 'Proppants',
        route: '/system_admin_proppants',
    },
    SYSTEM_ADMIN_DRIVERS: {
        title: 'Drivers',
        route: '/system_admin_drivers',
    },
    SYSTEM_ADMIN_CARRIERS: {
        title: 'Carriers',
        route: '/system_admin_carriers',
    },
    SYSTEM_ADMIN_SETTINGS: {
        title: 'Settings',
        route: '/system_admin_settings',
    },
    SYSTEM_ADMIN_YARDS: {
        title: 'Yards',
        route: '/system_admin_yards',
    },
    EMAIL: {
        title: 'Email',
        route: '/email',
    },
    PROFILE: {
        title: 'View Profile',
        route: '/profile',
    },
    CALLBACK: {
        title: 'Callback',
        route: '/callback',
    },
    SILENT_RENEW: {
        title: 'Silent Renew',
        route: '/silent-renew',
    },
    JOB_PROFILE: {
        title: 'Job Profile',
        route: '/job_profile/',
    },
    LOAD_MANAGEMENT: {
        title: 'Load Management',
        route: '/loads/',
    },
    LOAD_MANAGEMENT_WITH_ID: {
        title: '',
        route: '/loads/:jobId',
    },
    EDIT_JOB: {
        title: 'Edit Job',
        route: '/edit_job/',
    },
    EDIT_JOB_WITH_ID: {
        title: '',
        route: '/edit_job/:jobId',
    },
    JOB_LOADS: {
        title: 'Job Loads',
        route: '/job_loads/',
    },
    JOB_LOADS_WITH_ID: {
        title: '',
        route: '/job_loads/:jobId',
    },
    LOAD_PROFILE: {
        title: 'Load Profile',
        route: '/load_profile/',
    },
    LOAD_FIELD_OP: {
        title: 'Load Field Sign off',
        route: '/load_field_op/',
    },
    LOAD_FIELD_OP_WITH_ID: {
        title: 'Load Field Sign off',
        route: '/load_field_op/:loadId',
    },
    LOAD_PROFILE_WITH_ID: {
        title: '',
        route: '/load_profile/:loadId',
    },
    CHANGE_PASSWORD: {
        title: 'Change Password',
        route: '/change_password',
    },
    LOAD_HISTORY: {
        title: 'Load History',
        route: '/load_history/',
    },
    LOAD_HISTORY_WITH_ID: {
        title: '',
        route: '/load_history/:loadId',
    },
    JOB_ACTIVITY: {
        title: '',
        route: '/job_activity/',
    },
    DRIVER_POOL: {
        title: '',
        route: '/driver_pool/',
    },
    DRIVER_POOL_WITH_ID: {
        title: '',
        route: '/driver_pool/:jobId',
    },
    DAILY_SAND_ALLOCATIONS: {
        title: '',
        route: '/daily_sand_allocation/',
    },
    DAILY_SAND_ALLOCATIONS_WITH_ID: {
        title: '',
        route: '/daily_sand_allocation/:jobId',
    },
    JOB_METRICS: {
        title: '',
        route: '/job_metrics/',
    },
    JOB_METRICS_WITH_ID: {
        title: '',
        route: '/job_metrics/:jobId',
    },
    JOB_ACTIVITY_WITH_ID: {
        title: '',
        route: '/job_activity/:jobId',
    },
    JOB_MAP: {
        title: '',
        route: '/job_map/',
    },
    JOB_MAP_WITH_ID: {
        title: '',
        route: '/job_map/:jobId',
    },
    MESSAGES: {
        title: 'Messages',
        route: '/messages/',
    },
    MESSAGES_WITH_ID: {
        title: '',
        route: '/messages/:messageId',
    },
    MESSAGES_WITH_DRIVER_ID: {
        title: '',
        route: '/messages/:messageId/:conversationId',
    },
    MESSAGES_CREATE: {
        title: '',
        route: '/messages_create',
    },
    STAGE_SUMMARY: {
        title: 'Stage Summary',
        route: '/stage_summary/',
    },
    STAGE_SUMMARY_WITH_ID: {
        title: 'Stage Summary',
        route: '/stage_summary/:jobId',
    },
    STAGE_SHEET: {
        title: 'Stage Sheet',
        route: '/stage_sheet/',
    },
    STAGE_SHEET_BELLY_DUMP: {
        title: 'Stage Sheet bd',
        route: '/stage_sheet_bd/',
    },
    STAGE_SHEET_BELLY_DUMP_WITH_ID: {
        title: 'Stage Sheet bd',
        route: '/stage_sheet_bd/:stageSheetId',
    },
    STAGE_SHEET_RO: {
        title: 'Stage Sheet readonly',
        route: '/stage_sheet_ro/',
    },
    STAGE_SHEET_RO_WITH_ID: {
        title: 'Stage Sheet readonly',
        route: '/stage_sheet_ro/:stageSheetId',
    },
    STAGE_SHEET_BELLY_DUMP_RO: {
        title: 'Stage Sheet readonly',
        route: '/stage_sheet_bd_ro/',
    },
    STAGE_SHEET_BELLY_DUMP_RO_WITH_ID: {
        title: 'Stage Sheet readonly',
        route: '/stage_sheet_bd_ro/:stageSheetId',
    },
    STAGE_SHEET_WITH_ID: {
        title: 'Stage Sheet',
        route: '/stage_sheet/:stageSheetId',
    },
    INVENTORY: {
        title: 'Inventory',
        route: '/inventory/',
    },
    INVENTORY_WITH_ID: {
        title: 'Inventory',
        route: '/inventory/:jobId',
    },
    ADD_BOXES: {
        title: 'Add Boxes',
        route: '/add_boxes/',
    },
    ADD_BOXES_WITH_ID: {
        title: 'Add Boxes',
        route: '/add_boxes/:jobId/:stageSheetId',
    },
    JOB_LOGS: {
        title: 'Job Logs',
        route: '/job_logs/',
    },
    JOB_LOGS_WITH_ID: {
        title: 'Job Logs',
        route: '/job_logs/:jobId',
    },
    EQUIPMENT: {
        title: 'Equipment',
        route: '/equipment/'
    },
    EQUIPMENT_WITH_ID: {
        title: 'Equipment',
        route: '/equipment/:jobId'
    },
    EQUIPMENT_MANAGEMENT: {
        title: 'Asset Loads',
        route: '/asset_load/'
    },
    EQUIPMENT_MANAGEMENT_WITH_ID: {
        title: 'Asset Loads',
        route: '/asset_load/:loadId'
    },
    EDIT_ASSET_LOAD: {
        title: 'Edit Asset Loads',
        route: '/edit_asset_load/'
    },
    EDIT_ASSET_LOAD_WITH_ID: {
        title: 'Edit Asset Loads',
        route: '/edit_asset_load/:loadId'
    },
    EQUIPMENT_HISTORY: {
        title: 'Equipment Load History',
        route: '/equipment_load_history/',
    },
    EQUIPMENT_HISTORY_WITH_ID: {
        title: '',
        route: '/equipment_load_history/:loadId',
    },
    VOS:{
        title:"vos",
        route:'/vos/'
    },
    VOS_WITH_ID:{
        title:"vos",
        route:'/vos/:jobId'
    },
    DASHBOARD_VOS:{
        title:'Dashboard Vos',
        route:'/dashboard_vos/'
    },
    DASHBOARD_MAP:{
        title:'Dashboard Map',
        route:'/dashboard_map'
    }
};

